import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown, Menu } from 'antd';
import { CheckIconBold } from '../../../custom_shared/icons';
import { useAppStore } from '../../stores';
import { FilterIcon } from '../../../custom_shared/icons';
import './ContractComparisonFilterDropdown.less';

const ContractComparisonFilterDropdown: React.FC = () => {
    const { contractComparisonStore } = useAppStore();

    const [menuVisible, setMenuVisible] = React.useState(false);

    const moreActionsMenu = (
        <Menu onClick={() => setMenuVisible(false)}>
            {contractComparisonStore.filterOptions.map(option => (
                <Menu.Item key={option.value} onClick={() => contractComparisonStore.setSelectedFilter(option.value)}>
                    <div className="dropdown-icon-container">
                        {option.value === contractComparisonStore.selectedFilter && (
                            <CheckIconBold width={20} height={20} color="#000" />
                        )}
                    </div>
                    <span className={`dropdown-label ${option.value}`}>{option.label}</span>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Dropdown
            overlayClassName="contract-comparison-filter-dropdown"
            placement="bottomRight"
            visible={menuVisible}
            overlay={moreActionsMenu}
            onVisibleChange={setMenuVisible}
            trigger={['click']}
        >
            <div className="contract-comparison-filter-button">
                <FilterIcon color="#717887" />
                {contractComparisonStore.selectedFilterOption && (
                    <span className="filter-button-label">{contractComparisonStore.selectedFilterOption.label}</span>
                )}
            </div>
        </Dropdown>
    );
};

export default observer(ContractComparisonFilterDropdown);
